/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import map from 'lodash/map';
import uniqBy from 'lodash/uniqBy';
import _ from '../../translations';
import get from 'lodash/get';

class Tags extends Component {
    constructor(props) {
        super(props);

        let options = uniqBy(map(props.value, option => ({ text: option, value: option })), 'value');

        this.state = { options };
    }

    handleAddition = (e, { value }) => {
        const { maxLength, separateByComma = false }  = this.props;
        const values = separateByComma ? 
            value.split(',').map(v => ({
                text: v,
                value: v
            })) : [{
                text: value,
                value
            }];
        const options = uniqBy([...values, ...this.state.options], 'value');

        if (!maxLength || options.map(element => element.value).join(',').length <= maxLength)
            this.setState({
                options: uniqBy([...values, ...this.state.options], 'value'),
            });
    };

    shouldComponentUpdate(nextProps) {
        const { maxLength } = this.props;
        const { value = [] } = nextProps;

        if (maxLength && value.join(',').length >= maxLength)
            return false;

        return true;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (get(this.props, 'value', []).join(',') !== get(nextProps, 'value', []).join(',')) {
            const { maxLength, separateByComma = false } = this.props;
            const values = separateByComma ? nextProps.value.join(',').split(',') : nextProps.value;

            if (!maxLength || nextProps.value.join(',').length <= maxLength) {
                const newOptions = values.map(option => ({
                    text: option,
                    value: option,
                }));

                this.setState({
                    options: uniqBy([...newOptions, ...this.state.options], 'value'),
                });
            }
        }
    }

    render() {
        const placeholder = this.props?.placeholder || _('Tags');
        return (
            <Form.Dropdown
                {...this.props}
                options={this.state.options}
                placeholder={placeholder}
                search
                selection
                allowAdditions
                multiple
                onAddItem={this.handleAddition}
                noResultsMessage={null}
                icon={null}
            />
        );
    }
}

export default Tags;
